import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import VoiceCallConfig from '@/data/models/domain/VoiceCallConfig'
import type { ModelRaw } from '@/types'
import OrmApiRepository from '@/data/repositories/ormApiRepository'

@RepoSettings<Endpoint>({
  model: VoiceCallConfig,
})
@injectable()
@injectFromBase()
export default class VoiceCallConfigRepository extends OrmApiRepository<VoiceCallConfig> {
  protected readonly id = '1'

  public async getSettings() {
    const path = this.endpointsService.getPath('userVoiceCallSettings')

    const response = await this.getApiSource().get<ModelRaw<VoiceCallConfig>>(path)

    await this.insertOrUpdate([{ ...response.data, id: this.id }])
    return this.findEntityByIdOrFail(this.id)
  }
}
